(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("html2pdf", [], factory);
	else if(typeof exports === 'object')
		exports["html2pdf"] = factory();
	else
		root["html2pdf"] = factory();
})(self, function() {
return 